<template>
  <el-breadcrumb
    v-if="hasBreadcrumb"
    separator-class="el-icon-arrow-right"
    class="app--breadcrumb-items"
  >
    <el-breadcrumb-item class="breadcrumb--home">
      <nuxt-link to="/"><i class="fas fa-home" /></nuxt-link>
    </el-breadcrumb-item>

    <el-breadcrumb-item v-for="(b, i) in breadcrumb" :key="i">
      <nuxt-link v-if="!!b.to" :to="b.to" @click.native="handleLoading">{{
        b.text
      }}</nuxt-link>
      <template v-else>{{ b.text }}</template>
    </el-breadcrumb-item>
  </el-breadcrumb>

  <el-breadcrumb v-else separator-class="el-icon-arrow-right">
    <el-breadcrumb-item class="breadcrumb--home">
      <nuxt-link to="/"><i class="fas fa-home" /></nuxt-link>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
import { mapState } from 'vuex'
import LadSearchCustomLoadingMixin from '@/utils/mixin/search-custom-loading'

export default {
  name: 'LadBreadcrumbItems',
  mixins: [LadSearchCustomLoadingMixin],
  computed: {
    ...mapState('app', ['breadcrumb']),
    hasBreadcrumb() {
      return this.breadcrumb.length > 0
    },
  },
}
</script>

<style lang="scss">
.app--breadcrumb-items {
  .el-breadcrumb {
    line-height: 1.8;

    &__item {
      text-transform: capitalize;

      &.breadcrumb--home {
        a {
          color: #303133;
          cursor: pointer;
        }
      }
    }
  }

  .breadcrumb--home {
    min-width: 25px;
  }

  @media screen and (max-width: 500px) {
    .el-breadcrumb {
      display: table;

      &__item {
        float: initial;
        display: table-cell;
        vertical-align: middle;

        &:first-child {
          .el-breadcrumb__inner {
            padding-left: 0;
          }
        }
        &:last-child {
          .el-breadcrumb__inner {
            padding-right: 0;
          }
        }
      }

      &__inner {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        padding: 0 5px;
        line-height: 1.4;
      }

      &__separator {
        display: none;
      }
    }
  }
}
</style>
